import React from 'react';

export function CalyroLogo({ className = "h-8", showText = true, textClassName = "text-xl font-bold", transparent = false }) {
  return (
    <div className="flex items-center gap-1.5">
      {/* Logo Icon - Using actual image with proper aspect ratio */}
      <img 
        src={transparent ? "/calyro-logo-transparent.png" : "/calyro-logo.png"}
        alt="Calyro.ai Logo" 
        className={`${className} w-auto object-contain`}
      />
      
      {/* Brand Text */}
      {showText && (
        <span className={textClassName}>
          <span className="bg-gradient-to-r from-blue-600 via-indigo-600 to-purple-600 bg-clip-text text-transparent font-bold">
            Calyro
          </span>
          <span className="bg-gradient-to-r from-purple-600 to-pink-600 bg-clip-text text-transparent font-bold">.ai</span>
        </span>
      )}
    </div>
  );
}
